import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

// Declaration of USER module with using MODULES SCHEMA
export default {
	[ModulesConfigMap[ModulesMap.COMPANY].CREATE_COMPANY]: {
		url: '/companies/',
		requestOptions: {
			method: 'POST',
		},
	},
	[ModulesConfigMap[ModulesMap.COMPANY].GET_COMPANY]: {
		url: '/companies/:companyId/',
	},
	[ModulesConfigMap[ModulesMap.COMPANY].PATCH_COMPANY]: {
		url: '/companies/:companyId/',
		requestOptions: {
			method: 'PATCH',
		},
	},
	[ModulesConfigMap[ModulesMap.COMPANY].GET_AVAILABLE_USER_COMPANY_PERMISSIONS]: {
		url: '/companies/:companyId/permissions/',
	},
}
